import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor1Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "aca5d8ca-9abe-4ba5-afc9-214c19dc3af5", "general": {
  "name": "First Floor"
}, "artboards": [{
"background_type": "image",
"image_url": "https://greendirectorydata.s3.amazonaws.com/GPP8%20KP%201-1st%20FLOOR%20copy.png",
"width": 3905,
"height": 2790,
"use_image_size": true,
"children": [{
  "id": "3605438f-cf2f-4320-9fb3-2f80c7acb744",
  "title": "Poly",
  "type": "poly",
  "x": 56.61870503597123,
  "y": 7.205691847731492,
  "width": 41.07913669064747,
  "height": 41.68716639591552,
  "default_style": {
      "opacity": 0,
      "background_opacity": 0.306924682223487
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[9].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[9].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
          "fontFamily": "italiana",
          "fontSize": 20.8,
          "lineHeight": "normal",
          "color": "#ffffff",
          "textAlign": "left"
        },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[9].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[9].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[9].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/10';"
  },
  "x_image_background": 56.61870503597123,
  "y_image_background": 7.205691847731492,
  "points": [{
      "x": 100,
      "y": 0
  }, {
      "x": 0,
      "y": 0.24154589371980675
  }, {
      "x": 0.5253940455341506,
      "y": 92.512077294686
  }, {
      "x": 28.546409807355516,
      "y": 92.9951690821256
  }, {
      "x": 28.7215411558669,
      "y": 100
  }, {
      "x": 37.127845884413304,
      "y": 100
  }, {
      "x": 37.127845884413304,
      "y": 92.9951690821256
  }, {
      "x": 48.33625218914185,
      "y": 92.512077294686
  }, {
      "x": 48.51138353765324,
      "y": 36.95652173913043
  }, {
      "x": 100,
      "y": 36.95652173913043
  }]
}, {
  "id": "9fbf2e98-000c-4645-b8e3-39f74437dc64",
  "title": "Poly",
  "type": "poly",
  "x": 85.75377978866906,
  "y": 55.94381597638976,
  "width": 11.618705035971217,
  "height": 40.47884273226579,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[8].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[8].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[8].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[8].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[8].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/9';"
  },
  "x_image_background": 85.96960712679856,
  "y_image_background": 55.94381597638976,
  "points": [{
      "x": 0.30959752321981426,
      "y": 0.12437810945273632
  }, {
      "x": 99.69040247678018,
      "y": 0
  }, {
      "x": 100,
      "y": 25
  }, {
      "x": 85.44891640866872,
      "y": 25
  }, {
      "x": 87.61609907120743,
      "y": 100
  }, {
      "x": 0,
      "y": 100
  }]
}, {
  "id": "28fcfb27-cdae-481a-be9f-923b34be3817",
  "title": "Poly",
  "type": "poly",
  "x": 75.64586611960432,
  "y": 55.89346915707101,
  "width": 10.071942446043167,
  "height": 40.62988319022202,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[7].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[7].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[7].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[7].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[7].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/8';"
  },
  "x_image_background": 75.86169345773382,
  "y_image_background": 55.89346915707101,
  "points": [{
      "x": 0,
      "y": 0
  }, {
      "x": 99.64285714285714,
      "y": 0.12391573729863693
  }, {
      "x": 100,
      "y": 99.75216852540272
  }, {
      "x": 0,
      "y": 100
  }]
}, {
  "id": "24b6800a-7977-4227-85dc-d128a1e6314d",
  "title": "Poly",
  "type": "poly",
  "x": 65.60989928760117,
  "y": 55.94381597638976,
  "width": 10,
  "height": 40.57953637090327,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[6].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[6].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[6].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[6].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/7';"
  },
  "x_image_background": 65.82572662573067,
  "y_image_background": 55.94381597638976,
  "points": [{
      "x": 0,
      "y": 0
  }, {
      "x": 100,
      "y": 0.12406947890818859
  }, {
      "x": 100,
      "y": 100
  }, {
      "x": 0,
      "y": 99.87593052109182
  }]
}, {
  "id": "92d4b703-e7a1-499b-b427-a8c816288e9e",
  "title": "Poly",
  "type": "poly",
  "x": 55.53795245053957,
  "y": 55.84312233775227,
  "width": 10,
  "height": 40.73057682885949,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[5].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[5].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[5].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[5].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/6';"
  },
  "x_image_background": 55.753779788669064,
  "y_image_background": 55.84312233775227,
  "points": [{
      "x": 0,
      "y": 0
  }, {
      "x": 99.64028776978418,
      "y": 0.12360939431396785
  }, {
      "x": 100,
      "y": 100
  }, {
      "x": 0,
      "y": 100
  }]
}, {
  "id": "dd028222-be86-4fec-b8af-e2faa3b4a4b0",
  "title": "Poly",
  "type": "poly",
  "x": 45.39406755845324,
  "y": 55.89346915707101,
  "width": 10.071942446043167,
  "height": 40.68023000954075,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[4].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[4].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[4].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[4].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/5';"
  },
  "x_image_background": 45.60989489658273,
  "y_image_background": 55.89346915707101,
  "points": [{
      "x": 1.0714285714285714,
      "y": 0
  }, {
      "x": 98.92857142857143,
      "y": 0.3712871287128713
  }, {
      "x": 100,
      "y": 100
  }, {
      "x": 0,
      "y": 99.87623762376238
  }]
}, {
  "id": "e8506ae2-1ca2-442b-870d-7bc16b4f2f4a",
  "title": "Poly",
  "type": "poly",
  "x": 35.358097433186266,
  "y": 55.94381597638976,
  "width": 10.071942446043167,
  "height": 40.57953637090327,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[3].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[3].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[3].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[3].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/4';"
  },
  "x_image_background": 35.57392477131576,
  "y_image_background": 55.94381597638976,
  "points": [{
      "x": 0,
      "y": 0
  }, {
      "x": 98.21428571428571,
      "y": 0.12406947890818859
  }, {
      "x": 100,
      "y": 100
  }, {
      "x": 0,
      "y": 99.87593052109182
  }]
}, {
  "id": "c4676be6-c8ca-47df-9efc-ef9b19c75cc5",
  "title": "Poly",
  "type": "poly",
  "x": 25.322126210164683,
  "y": 55.99416279570849,
  "width": 10.03597122302158,
  "height": 40.57953637090327,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[2].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[2].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[2].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[2].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/3';"
  },
  "x_image_background": 25.466011102251013,
  "y_image_background": 55.99416279570849,
  "points": [{
      "x": 0.35842293906810035,
      "y": 0
  }, {
      "x": 98.9247311827957,
      "y": 0
  }, {
      "x": 100,
      "y": 100
  }, {
      "x": 0,
      "y": 99.87593052109182
  }]
}, {
  "id": "2244c2c1-b2e0-444a-8bdc-9f13816f1cbf",
  "title": "Poly",
  "type": "poly",
  "x": 15.215827338129497,
  "y": 55.94141294827041,
  "width": 10.107913669064748,
  "height": 40.68023000954075,
  "default_style": {
      "opacity": 0
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[1].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[1].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[1].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[1].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/2';"
  },
  "x_image_background": 15.467625899280577,
  "y_image_background": 55.94141294827041,
  "points": [{
      "x": 1.0676156583629914,
      "y": 0
  }, {
      "x": 98.93238559175337,
      "y": 0.1237601603798942
  }, {
      "x": 100,
      "y": 99.75247524752474
  }, {
      "x": 0,
      "y": 100
  }]
}, {
  "id": "e78dd7d1-f6c7-41d0-9903-43129333ac21",
  "title": "Poly",
  "type": "poly",
  "x": 5.107913669064747,
  "y": 55.941413549214424,
  "width": 10.215827338129497,
  "height": 40.68023000954074,
  "default_style": {
      "opacity": 0,
      "background_opacity": 0.306924682223487
  },
  "mouseover_style": {
      "background_color": unitStatus && unitStatus[0].status === "available" ? "#0e2b33" : "#a6a1a6",
      "background_opacity": 1
  },
  "tooltip_style": {
      "background_color": "#0e2b33"
  },
  "tooltip_content": [{
      "type": "Heading",
      "text": unitStatus && unitStatus[0].unitTitle,
      "heading": "h3",
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "italiana",
        "fontSize": 20.8,
        "lineHeight": "normal",
        "color": "#ffffff",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
  },
  // {
  //     "type": "Paragraph",
  //     "text": unitStatus && unitStatus[0].marketing,
  //     "other": {
  //         "id": "",
  //         "classes": "",
  //         "css": ""
  //     },
  //     "style": {
  //       "fontFamily": "barlow",
  //       "fontSize": 26,
  //       "lineHeight": 22,
  //       "color": "#ad937b",
  //       "textAlign": "left"
  //     },
  //     "boxModel": {
  //         "width": "auto",
  //         "height": "auto",
  //         "margin": {
  //             "top": 0,
  //             "bottom": 0,
  //             "left": 0,
  //             "right": 0
  //         },
  //         "padding": {
  //             "top": 10,
  //             "bottom": 10,
  //             "left": 10,
  //             "right": 10
  //         }
  //     },
  //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  // },
  {
      "type": "Paragraph",
      "text": unitStatus && unitStatus[0].status.toUpperCase(),
      "other": {
          "id": "",
          "classes": "",
          "css": ""
      },
      "style": {
        "fontFamily": "barlow",
        "fontSize": 26,
        "lineHeight": 22,
        "color": "#ad937b",
        "textAlign": "left"
      },
      "boxModel": {
          "width": "auto",
          "height": "auto",
          "margin": {
              "top": 0,
              "bottom": 0,
              "left": 0,
              "right": 0
          },
          "padding": {
              "top": 10,
              "bottom": 10,
              "left": 10,
              "right": 10
          }
      },
      "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
  }],
  "actions": {
      "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
      "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/1/1';"
  },
  "x_image_background": 5.179856115107913,
  "y_image_background": 55.84071930963294,
  "points": [{
      "x": 98.59154929577466,
      "y": 0.49504950495049505
  }, {
      "x": 0,
      "y": 0
  }, {
      "x": 0.7042253521126761,
      "y": 100
  }, {
      "x": 100,
      "y": 100
  }]
}]
}], "version": "6.0.20"
});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor1Component;
